// on scroll header fixed JS
$(window).scroll(function () {
  var scroll = $(window).scrollTop();
  if (scroll >= 120) {
    $("body").addClass("la-header-sec-sticky");
  } else {
    $("body").removeClass("la-header-sec-sticky");
  }
});

// megamenu JS
$(document).ready(function () {
  // copy button code js
  $(".copy-btn").on("click", function (e) {
    e.preventDefault();
    var copyText = document.getElementById("discount_get");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand("copy");
  });

  // cart page gift promo js
  $(".la_gift_show_code > a").on("click", function () {
    $(".discount_box_cart").show();
  });

  // product page custom js
  $(".discount_information_area").on("click", function () {
    $(".discount_information_area_popup_box").show();
  });

  $(".close_popup_box_icon").on("click", function () {
    $(".discount_information_area_popup_box").hide();
  });

  $("button.cstm_shop_emnu").click(function (eve) {
    eve.stopPropagation();
    $(this).toggleClass("site_nav_active");
    $(".la-m-menu-main-sec").toggleClass("la-m-menu-main-sec-open");
    $("header").toggleClass("la-m-menu-main-sec-open-head");
  });

  $("html").click(function () {
    $("button.cstm_shop_emnu").removeClass("site_nav_active");
    $(".la-m-menu-main-sec").removeClass("la-m-menu-main-sec-open");
    $("header").removeClass("la-m-menu-main-sec-open-head");
  });

  // footer accordian JS
  $("#accordion-demo").accordiom();
  $("#accordion-demo_new").accordiom();

  // mobile toggle JS
  $(".la-mob-menu-toggle-box").click(function () {
    $(this).toggleClass("la-mob-menu-toggle-box-open");
    $("header").toggleClass("la-m-menu-main-sec-open-head");
    $("body").toggleClass("la-mob-drop-menu-sec-open");
  });

  // Custom quantity box
  // Checks maximum quantity from selected option and add it as attribute to the + button
  var addInput = "#Quantity";
  var n = 1;
  var initialQuantity = $(
    "select[id^='ProductSelect-']:first option:selected",
  ).attr("qty");
  // Set max quantity for the product
  // $(addInput).attr("max", initialQuantity).val(n);

  // Add + button click event
  $(".plus").on("click", function () {
    const currentQuantity = parseInt($(addInput).val());
    // const maxQuantity = parseInt($(addInput).attr("max"));
    // if (currentQuantity < maxQuantity) {
    $(addInput).val(++n);
    // }
  });

  $(".min").on("click", function () {
    if (n > 1) {
      $(addInput).val(--n);
    }
  });

  // Select swatch option on click
  $("body").on("click", ".swatch-element", function () {
    var value1 = $(this).attr("data-value1");
    $("select[id^='ProductSelect-']:first option[value='" + value1 + "']").prop(
      "selected",
      true,
    );
    var qty = $(
      "select[id^='ProductSelect-']:first option[value='" + value1 + "']",
    )
      .prop("selected", true)
      .attr("qty");
    // Set max quantity for the product
    // $("#Quantity").attr("max", qty);

    if (qty == 0) {
      $(".cstm_cart_add").prop("disabled", true);
      $(".cstm_cart_add span").html("Sold Out");
    }
    if (qty > 0) {
      $(".cstm_cart_add").prop("disabled", false);
      $(".cstm_cart_add span").html("Add to cart");
      // Reset selected quantity
      // n = 1;
      // $(addInput).val(n);
    }
  });
  // });

  // recharge app code
  $("body").on("click", ".la_dleivery_btns ul li", function () {
    var value2 = $(this).attr("value");
    $(".la_dleivery_btns ul li").removeClass("la-delivery-day-active");
    $(this).addClass("la-delivery-day-active");
    $(".cstm_drop_down_app option[value='" + value2 + "']").prop(
      "selected",
      true,
    );
  });

  $(":radio").change(function () {
    // var id_radio = $(this).attr("value");
    //console.log(id_radio);
    if ($(this).val() == "onetime") {
      $(".la_dleivery_btns").hide();
    } else if ($(this).val() == "autodeliver") {
      $(".la_dleivery_btns").show();
    }
  });

  // smooth scroll
  $('a[href^="#roaster_notes"]').on("click", function (e) {
    e.preventDefault();
    var target = this.hash;
    var $target = $(target);
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $target.offset().top,
        },
        1200,
        "swing",
        function () {
          window.location.hash = target;
        },
      );
  });

  //product scroll bar
  $("#content-5").mCustomScrollbar({
    axis: "x",
    mouseWheelPixels: 500,
    scrollInertia: 500,
    advanced: { autoExpandHorizontalScroll: true },
  });

  $("body").on("click", "a.la_gift_link", function () {
    $(this).css("display", "none");
    $(".tbn__cd_id_discount-field").css("display", "block");
  });
});
